import screensPolyfill from './react-native-screens.web.js';
import nativeStackPolyfill from './react-native-screens-native-stack.web.js';

if (typeof globalThis !== 'undefined') {
  if (!globalThis.__RN_SCREENS_POLYFILL__) {
    globalThis.__RN_SCREENS_POLYFILL__ = screensPolyfill;
  }
  if (!globalThis.__RN_SCREENS_NATIVE_STACK_POLYFILL__) {
    globalThis.__RN_SCREENS_NATIVE_STACK_POLYFILL__ = nativeStackPolyfill;
  }
}
